import { SEARCH_RESULT_CONTENT_TYPE, SEARCH_TAB_TYPE, SearchResult } from '~/portal/types/search'

export const buildSearchParams = (query: string, type: SEARCH_TAB_TYPE, productId?: string) => ({
  type,
  q: query,
  ...(productId ? { productId } : {}),
})

export const isAsyncApi = (result: SearchResult) =>
  result.contentType === SEARCH_RESULT_CONTENT_TYPE.ASYNC_API

export const isGraphQl = (result: SearchResult) =>
  result.contentType === SEARCH_RESULT_CONTENT_TYPE.GRAPH_QL

export const isMcp = (result: SearchResult) =>
  result.contentType === SEARCH_RESULT_CONTENT_TYPE.MCP

export const isA2a = (result: SearchResult) =>
  result.contentType === SEARCH_RESULT_CONTENT_TYPE.A2A

export const isGrpc = (result: SearchResult) =>
  result.contentType === SEARCH_RESULT_CONTENT_TYPE.GRPC

export const isDefinitionMarkdown = (result: SearchResult) =>
  isGraphQl(result) || isMcp(result) || isA2a(result) || isGrpc(result)